export const ENTRY_CATS = ['cat1', 'cat2', 'cat3']
export const ENTRY_CSV_FIELDS = [
	...ENTRY_CATS,
	'type',
	'label',
	'code',
	'description',
]
export const ENTRY_TYPES = ['event', 'task', 'interval']
export const ENTRY_LABEL_MAXCHARS = 40

// ERRORS

export class CatalogError extends Error {
	constructor(...args) {
		super(...args)
		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, CatalogError)
		}
		this.name = 'CatalogError'
	}
}
export class EntryError extends CatalogError {
	constructor(...args) {
		super(...args)
		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, EntryError)
		}
		this.name = 'EntryError'
	}
}

// CLASSES

export class Entry {
	// members
	cats
	type
	label
	code
	description
	constructor(line) {
		// collect category parents
		var cats = []
		for (const c of ENTRY_CATS) {
			var cat = line[c].trim()
			if (!cat) break
			cats.push(cat)
		}
		// check parent categories
		if (cats.length === 0) throw new EntryError(`no category`)
		else this.cats = cats
		// check type
		if (!ENTRY_TYPES.includes(line.type))
			throw new EntryError(`unknown type ${line.type}`)
		else this.type = line.type
		// check label
		if (!line.label.trim()) throw new EntryError(`empty label`)
		else if (line.label.length > ENTRY_LABEL_MAXCHARS)
			throw new EntryError(
				`Label must not exceed ${ENTRY_LABEL_MAXCHARS} characters`,
			)
		else this.label = line.label.trim()
		// others
		this.code = line.code
		this.description = line.description
	}
}

export default class Catalog {
	// members
	entries = [] // array of all catalog entries
	errors = []
	warnings = []
	status = 'idle' // one of 'idle', 'success', 'warning', 'error'

	get issues() {
		return [
			...this.errors.map(e => ['error', e]),
			...this.warnings.map(w => ['warning', w]),
		]
	}

	get imported() {
		return ['success', 'warning'].includes(this.status)
	}

	import(csv) {
		this.entries = []
		this.errors = []
		this.warnings = []

		// check the csv structure
		if (csv.meta.fields.join(', ') != ENTRY_CSV_FIELDS.join(', ')) {
			this.errors.push(
				'invalid CSV, expected fields: ' + ENTRY_CSV_FIELDS.join(', '),
			)
		}
		if (this.errors.length) {
			this.status = 'error'
			return false
		}

		// import each line
		for (const [i, l] of csv.data.entries()) {
			try {
				this.entries.push(new Entry(l))
			} catch (e) {
				this.warnings.push(`line #${i + 1} ignored: ${e.message}`)
			}
		}

		this.status = this.warnings.length > 0 ? 'warning' : 'success'
		return true // return true whatever
	}
}
